// wondr grain — Shopify theme scripts
(() => {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const R = window.WG_ROUTES || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search/suggest' };
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------------- cart (Shopify AJAX API) ---------------- */
  const syncCartCount = async () => {
    try {
      const res = await fetch(R.cart + '.js');
      const cart = await res.json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    } catch { /* offline */ }
  };
  const addToCart = async (variantId, qty) => {
    const res = await fetch(R.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 }),
    });
    if (!res.ok) throw new Error('add failed');
    await syncCartCount();
  };

  // Delegated add buttons (cards, reels, search panel, modal)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add]');
    if (!btn || !btn.dataset.variant) return;
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      await addToCart(btn.dataset.variant, 1);
      btn.textContent = 'Added ✓';
    } catch { btn.textContent = 'Try again'; }
    setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 1400);
  });

  // PDP form: qty stepper + AJAX submit
  const pdpForm = $('form[action*="/cart/add"]');
  if (pdpForm) {
    const out = $('[data-qty]', pdpForm);
    const hidden = $('[data-qty-input]', pdpForm);
    const buy = $('[data-add-form]', pdpForm);
    const unit = buy ? parseInt(buy.dataset.price, 10) : 0;
    const money = (paise) => '₹' + (paise / 100).toLocaleString('en-IN');
    const set = (n) => {
      if (out) out.textContent = n;
      if (hidden) hidden.value = n;
      if (buy && unit) buy.textContent = `Add to cart — ${money(unit * n)}`;
    };
    $('[data-qty-inc]', pdpForm)?.addEventListener('click', () => set(Math.min(99, parseInt(out.textContent, 10) + 1)));
    $('[data-qty-dec]', pdpForm)?.addEventListener('click', () => set(Math.max(1, parseInt(out.textContent, 10) - 1)));
    pdpForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!buy) return;
      const label = buy.textContent;
      buy.disabled = true; buy.textContent = 'Adding…';
      try {
        const fd = new FormData(pdpForm);
        const res = await fetch(R.cartAdd + '.js', { method: 'POST', body: fd });
        if (!res.ok) throw 0;
        await syncCartCount();
        buy.textContent = 'Added ✓';
      } catch { buy.textContent = 'Try again'; }
      setTimeout(() => { buy.textContent = label; buy.disabled = false; }, 1400);
    });
  }

  // Cart page: line quantity changes / remove
  document.addEventListener('click', async (e) => {
    const change = e.target.closest('[data-line-change]');
    const remove = e.target.closest('[data-line-remove]');
    if (!change && !remove) return;
    const line = Number((change || remove).dataset.lineChange || remove.dataset.lineRemove);
    let quantity = 0;
    if (change) {
      const out = change.parentElement.querySelector('output');
      quantity = Math.max(0, parseInt(out.textContent, 10) + Number(change.dataset.delta));
    }
    await fetch(R.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    location.reload();
  });

  /* ---------------- header search (predictive) ---------------- */
  const searchToggle = $('[data-search-toggle]');
  const searchBar = $('[data-search-bar]');
  const searchInput = $('[data-search-input]');
  const browsePane = $('[data-search-browse]');
  const resultsPane = $('[data-search-results]');
  const resultsGrid = $('[data-search-grid]');
  const resultsCount = $('[data-search-count]');
  if (searchToggle && searchBar && searchInput) {
    const closePanel = () => { searchBar.hidden = true; searchToggle.setAttribute('aria-expanded', 'false'); };
    searchToggle.addEventListener('click', () => {
      if (searchBar.hidden) { searchBar.hidden = false; searchToggle.setAttribute('aria-expanded', 'true'); searchInput.focus(); }
      else closePanel();
    });
    $('[data-search-close]')?.addEventListener('click', closePanel);
    let timer;
    const run = async () => {
      const q = searchInput.value.trim();
      if (q.length < 2) {
        if (browsePane) browsePane.hidden = false;
        if (resultsPane) resultsPane.hidden = true;
        return;
      }
      try {
        const url = `${R.search}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`;
        const res = await fetch(url);
        const data = await res.json();
        const hits = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (browsePane) browsePane.hidden = true;
        if (resultsPane) resultsPane.hidden = false;
        if (resultsCount) resultsCount.textContent = hits.length
          ? `${hits.length} result${hits.length === 1 ? '' : 's'} for \u201c${q}\u201d`
          : `Nothing matches \u201c${q}\u201d — try \u201cidiyappam\u201d or a grain name.`;
        if (resultsGrid) resultsGrid.innerHTML = hits.map((p) => `<article class="mini-card">
          <a class="mini-img" href="${p.url}"><img src="${esc(p.featured_image && p.featured_image.url)}" alt="${esc(p.title)}" loading="lazy"></a>
          <a class="mini-name" href="${p.url}">${esc(p.title)}</a>
          <div class="mini-foot"><span class="price">₹${p.price}</span>
            <a class="add-btn" href="${p.url}">View</a></div>
        </article>`).join('');
      } catch { /* predictive search unavailable */ }
    };
    searchInput.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 220); });
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); const q = searchInput.value.trim(); if (q) location.href = '/search?q=' + encodeURIComponent(q); }
      if (e.key === 'Escape') closePanel();
    });
    document.addEventListener('click', (e) => {
      if (!searchBar.hidden && !e.target.closest('.header')) closePanel();
    });
  }

  /* ---------------- mobile nav + dropdowns ---------------- */
  const navToggle = $('[data-nav-toggle]');
  const navLinks = $('#nav-links');
  if (navToggle && navLinks) {
    navToggle.addEventListener('click', () => {
      const open = navLinks.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', String(open));
    });
  }
  $$('.nav-item.has-drop > a').forEach((link) => {
    link.addEventListener('click', (e) => {
      const item = link.parentElement;
      const isTouch = window.matchMedia('(hover:none)').matches || window.innerWidth <= 880;
      if (isTouch && !item.classList.contains('open')) {
        e.preventDefault();
        $$('.nav-item.open').forEach((o) => o.classList.remove('open'));
        item.classList.add('open');
      }
    });
  });

  /* ---------------- PDP gallery hover swap ---------------- */
  const galleryMain = $('[data-gallery-main]');
  if (galleryMain) {
    const mainImg = $('img', galleryMain);
    const thumbs = $$('[data-thumb]');
    const show = (btn) => {
      const full = btn.dataset.full;
      if (!full || mainImg.src === full) return;
      thumbs.forEach((t) => t.classList.toggle('active', t === btn));
      galleryMain.classList.add('swapping');
      const img = new Image();
      img.onload = () => { mainImg.src = full; mainImg.removeAttribute('srcset'); galleryMain.classList.remove('swapping'); };
      img.src = full;
    };
    thumbs.forEach((btn) => {
      btn.addEventListener('mouseenter', () => show(btn));
      btn.addEventListener('focus', () => show(btn));
      btn.addEventListener('click', () => show(btn));
    });
  }

  /* ---------------- reels: arrows + modal ---------------- */
  $$('.reel-scroller').forEach((scroller) => {
    const row = $('[data-reel-row]', scroller);
    const prev = $('[data-reel-prev]', scroller);
    const next = $('[data-reel-next]', scroller);
    if (!row || !prev || !next) return;
    const step = () => {
      const card = row.querySelector('.reel-card');
      return card ? (card.getBoundingClientRect().width + 18) * 2 : row.clientWidth * 0.8;
    };
    const sync = () => {
      prev.disabled = row.scrollLeft <= 4;
      next.disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 4;
    };
    prev.addEventListener('click', () => row.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }));
    next.addEventListener('click', () => row.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }));
    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  const modal = $('[data-reel-modal]');
  if (modal) {
    const media = $('[data-modal-media]', modal);
    const titleEl = $('[data-modal-title]', modal);
    const descEl = $('[data-modal-desc]', modal);
    const prodEl = $('[data-modal-product]', modal);
    let lastFocus = null;
    const open = (btn) => {
      lastFocus = btn;
      const d = btn.dataset;
      titleEl.textContent = d.title || '';
      descEl.textContent = d.desc || '';
      const poster = btn.querySelector('img.reel-poster');
      media.innerHTML = d.remote
        ? `<video controls autoplay playsinline ${poster ? `poster="${poster.currentSrc || poster.src}"` : ''}><source src="${esc(d.remote)}" type="video/mp4"></video>`
        : (poster ? `<img src="${poster.currentSrc || poster.src}" alt="">` : '');
      prodEl.innerHTML = d.pname ? `
        <div class="rmp-row">
          <img src="${esc(d.pimg)}" alt="">
          <span><strong>${esc(d.pname)}</strong><span>${esc(d.pprice)}</span></span>
        </div>
        <div class="rmp-actions">
          <button class="add-btn" type="button" data-add data-variant="${esc(d.variant)}">Add to cart</button>
          <a class="chip" href="${esc(d.url)}">View product</a>
        </div>` : '';
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      $('.reel-modal-close', modal).focus();
    };
    const close = () => {
      modal.hidden = true;
      media.innerHTML = '';
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    };
    $$('[data-reel]').forEach((btn) => btn.addEventListener('click', () => open(btn)));
    $$('[data-modal-close]', modal).forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  /* ---------------- reveal + counters ---------------- */
  const revealEls = $$('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window && !reduced) {
    $$('.prod-grid, .cat-grid, .testi-grid, .trust-grid, .reel-row, .grain-row, .stat-band, .blog-grid').forEach((wrap) => {
      $$('.reveal', wrap).forEach((el, i) => el.style.setProperty('--d', (i % 8) * 0.07 + 's'));
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in-view'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    revealEls.forEach((el) => io.observe(el));
  } else revealEls.forEach((el) => el.classList.add('in-view'));

  const counters = $$('[data-count]');
  if (counters.length && 'IntersectionObserver' in window && !reduced) {
    const io2 = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        io2.unobserve(en.target);
        const el = en.target;
        const target = parseInt(el.dataset.count, 10) || 0;
        const t0 = performance.now(); const dur = 900;
        const tick = (t) => {
          const k = Math.min(1, (t - t0) / dur);
          el.textContent = Math.round(target * (1 - Math.pow(1 - k, 3)));
          if (k < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.6 });
    counters.forEach((el) => io2.observe(el));
  } else counters.forEach((el) => { el.textContent = el.dataset.count; });

  /* ---------------- apple-style scroll story ---------------- */
  const storySec = $('[data-scrollstory]');
  const stage = $('[data-scrollfx]');
  if (storySec && stage && !reduced) {
    const video = $('video', stage);
    const steps = $$('[data-story-step]', stage);
    let duration = 0;
    if (video) {
      video.addEventListener('loadedmetadata', () => { duration = video.duration || 0; });
      video.addEventListener('canplay', () => { try { video.pause(); } catch (err) {} }, { once: true });
    }
    const update = () => {
      const track = storySec.querySelector('.scrollstory-track') || storySec;
      const r = track.getBoundingClientRect();
      const vh = window.innerHeight || 1;
      const total = r.height - vh;
      const progress = Math.max(0, Math.min(1, -r.top / (total || 1)));
      const k = Math.min(1, progress / 0.2);
      stage.style.transform = `scale(${(0.88 + 0.12 * k).toFixed(3)}) rotateX(${(8 * (1 - k)).toFixed(2)}deg)`;
      stage.style.opacity = (0.75 + 0.25 * k).toFixed(3);
      if (video && duration) {
        const t = progress * duration * 0.98;
        if (Math.abs((video.currentTime || 0) - t) > 0.04) { try { video.currentTime = t; } catch (err) {} }
      }
      const idx = Math.min(steps.length - 1, Math.floor(progress * steps.length));
      steps.forEach((el, i) => el.classList.toggle('step-on', i === idx));
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  } else if (stage) {
    stage.style.transform = 'none';
    stage.style.opacity = '1';
  }

  /* ---------------- wishlist (localStorage) ---------------- */
  const WISH_KEY = 'wg_wishlist';
  const wishes = () => { try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch { return []; } };
  $$('[data-wish]').forEach((b) => { if (wishes().includes(b.dataset.wish)) b.setAttribute('aria-pressed', 'true'); });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (!b) return;
    let w = wishes();
    const h = b.dataset.wish;
    w = w.includes(h) ? w.filter((x) => x !== h) : w.concat(h);
    localStorage.setItem(WISH_KEY, JSON.stringify(w));
    $$(`[data-wish="${h}"]`).forEach((x) => x.setAttribute('aria-pressed', String(w.includes(h))));
  });

  /* ---------------- back to top ---------------- */
  const toTop = $('[data-to-top]');
  if (toTop) {
    const sync = () => { toTop.hidden = window.scrollY < 600; };
    window.addEventListener('scroll', sync, { passive: true });
    sync();
    toTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  syncCartCount();
})();
